export default function (isMadeToOrder) {
  return isMadeToOrder ? 'Made to Order' : null
}
